// extracted by mini-css-extract-plugin
export default {"Container":"payroll_Container__pY61c","section-1":"payroll_section-1__eL05E","content":"payroll_content__Y1d4H","section-2":"payroll_section-2__KP3ra"};